import _ from "lodash";
import React from "react";
import { ICategoryDto } from "../../../models/CategoryDto";
import './ProductButton.css';
import { ProductButtonProps } from "./ProductButtonProps";
import {ReactComponent as Dots} from "../../../resources/images/dots.svg";
import {ReactComponent as Camera} from "../../../resources/images/camera.svg";
import CloseMenuIcon from "../../../resources/wrappers/menu/CloseMenuIcon";
import { AppUtils } from "../../../utils/AppUtils";
import $ from 'jquery';
import { IProductDto } from "../../../models/ProductDto";
import { Route } from "react-router";
import * as querystring from 'querystring';
import { eventDispatcher } from "../../../services/events/EventDispatcher";
import { EventType } from "../../../services/events/EventType";
import Media from "react-media";
import DOMPurify from 'dompurify'

export class ProductButton extends React.Component<ProductButtonProps, any>{
    private eventSubscription: any = null;
    private readonly MAX_CATEGORY_BADGES_DESKTOP = 10;
    private readonly MAX_CATEGORY_BADGES_MOBILE = 7;

    constructor(props: ProductButtonProps){
        super(props);

        this.state = {
            menuOpened: false,
            topCategoryProductMenu: 0,
            leftCategoryProductMenu: 0,
            nCategories: 0,
            categoriesToShow: 0,
            remainingCategories: 0,
            product: undefined,
            description: ""
        }
    }

    componentDidMount(){
        this.eventSubscription = eventDispatcher.getEventObserver().subscribe((event) => {
            if(EventType.CLOSE_PRODUCT_POPUP === event){
                this.closeMenu();
            }
        })
        let nCategories: number = (this.props.product.categories !== undefined) ? this.props.product.categories?.length! : 0;
        this.setState({nCategories: nCategories})
        let isMobile = window.matchMedia("(max-width: 1064px)").matches;
        if(isMobile){
            if(nCategories > this.MAX_CATEGORY_BADGES_MOBILE){
                let width = window.outerWidth;
                let minimun = width < 376;
                let small = width < 320;
                let smallest = width < 290;
                let moreSmallest = width < 260;
                let nCategories = (this.props.product.categories !== undefined) ? this.props.product.categories?.length! : 0;
                if(nCategories > this.MAX_CATEGORY_BADGES_MOBILE){
                    if(moreSmallest){
                        let remaining = nCategories - 3;
                        this.setState({categoriesToShow: 3});
                        this.setState({remainingCategories: remaining});
                    } else if(smallest){
                        let remaining = nCategories - 4;
                        this.setState({categoriesToShow: 4});
                        this.setState({remainingCategories: remaining});
                    } else if(small){
                        let remaining = nCategories - 5;
                        this.setState({categoriesToShow: 5});
                        this.setState({remainingCategories: remaining});
                    } else if(minimun){
                        let remaining = nCategories - 6;
                        this.setState({categoriesToShow: 6});
                        this.setState({remainingCategories: remaining});
                    } else {
                        let remaining = nCategories - this.MAX_CATEGORY_BADGES_MOBILE;
                        this.setState({categoriesToShow: this.MAX_CATEGORY_BADGES_MOBILE});
                        this.setState({remainingCategories: remaining});
                    }
                }
            } else {
                this.setState({categoriesToShow: nCategories});
                this.setState({remainingCategories: 0});
            }
        } else {
            if(nCategories > this.MAX_CATEGORY_BADGES_DESKTOP){
                let remaining = nCategories - this.MAX_CATEGORY_BADGES_DESKTOP;
                this.setState({categoriesToShow: this.MAX_CATEGORY_BADGES_DESKTOP});
                this.setState({remainingCategories: remaining});
            } else {
                this.setState({categoriesToShow: nCategories});
                this.setState({remainingCategories: 0});
            }
        }
        this.setState({product: this.props.product})
        this.manageFirstDescriptionResize();
        this.manageResizeCategoriesBadges();
        window.addEventListener('resize', (event: any) => {
            this.manageResizeForProductButton();
            this.manageResizeCategoriesBadges();
            this.manageDescriptionResizing(event);
        });
    }

    componentWillUnmount(){
        if(this.eventSubscription !== null){
            this.eventSubscription.unsubscribe();
        }

        window.removeEventListener('resize', (event: any) => {
            this.manageResizeForProductButton();
            this.manageResizeCategoriesBadges();
            this.manageDescriptionResizing(event);
        });
    }

    private manageResizeForProductButton(){
        let divProductName = this.state.product.productId;
        let element = document.getElementById(divProductName);
        if(element !== undefined){
            if(this.state.menuOpened === true){
                if(!AppUtils.isPhoneOrTablet()){
                    let left = element?.offsetLeft;
                    let top = element?.offsetTop;
                    top = top! + 89 + 10;
                    left = left! + 110;
                    this.setState({topCategoryProductMenu: top});
                    this.setState({leftCategoryProductMenu: left});

                    window.scrollTo({
                        top: element?.offsetTop,
                        behavior: 'smooth'
                    });
                } else {
                    let left = element?.offsetLeft;
                    let top = element?.offsetTop;
                    let newTop = top!! + 89 + 10;

                    this.setState({topCategoryProductMenu: newTop});
                    this.setState({leftCategoryProductMenu: left});

                    window.scrollTo({
                        top: element?.offsetTop,
                        behavior: 'smooth'
                    });
                }
            }
        }
    }

    private manageResizeCategoriesBadges(){
        let isMobile = window.matchMedia("(max-width: 1064px)").matches;
        if(isMobile){
            let width = window.outerWidth;
            let minimun = width < 376;
            let small = width < 320;
            let smallest = width < 290;
            let moreSmallest = width < 260;
            let nCategories = this.state.nCategories;
            if(nCategories > this.MAX_CATEGORY_BADGES_MOBILE){
                if(moreSmallest){
                    let remaining = nCategories - 3;
                    this.setState({categoriesToShow: 3});
                    this.setState({remainingCategories: remaining});
                } else if(smallest){
                    let remaining = nCategories - 4;
                    this.setState({categoriesToShow: 4});
                    this.setState({remainingCategories: remaining});
                } else if(small){
                    let remaining = nCategories - 5;
                    this.setState({categoriesToShow: 5});
                    this.setState({remainingCategories: remaining});
                } else if(minimun){
                    let remaining = nCategories - 6;
                    this.setState({categoriesToShow: 6});
                    this.setState({remainingCategories: remaining});
                } else {
                    let remaining = nCategories - this.MAX_CATEGORY_BADGES_MOBILE;
                    this.setState({categoriesToShow: this.MAX_CATEGORY_BADGES_MOBILE});
                    this.setState({remainingCategories: remaining});
                }
            }
        }
    }

    private manageFirstDescriptionResize(){
        let isMobile = window.matchMedia("(max-width: 1064px)").matches;
        if(isMobile){
            let elements = document.getElementsByClassName('product-button-product-description');
            for(let i = 0; i < elements.length; i++){
                let element = elements.item(i);
                if(element !== null){
                    let computedId = this.props.product.productId + '_description';
                    if(element.id === computedId){
                        if(element.scrollHeight > 32){
                            if(element.textContent !== null){
                                element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
                                if(element.id === computedId) {
                                    for(;;){
                                        if(element.scrollHeight <= 32){
                                            break;
                                        } else {
                                            element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
                                            if(element.scrollHeight <= 32){
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            let computedId = this.props.product.productId + '_description';
                            if(element.id === computedId){
                                element.textContent = this.props.product.descr;
                            }
                        }
                    }   
                }
            }
        }
    }

    private manageDescriptionResizing(event: any){
        let isMobile = window.matchMedia("(max-width: 1064px)").matches;
        if(isMobile){
            let elements = document.getElementsByClassName('product-button-product-description');
            for(let i = 0; i < elements.length; i++){
                let element = elements.item(i);
                if(element !== null){
                    let computedId = this.props.product.productId + '_description';
                    if(element.id === computedId){
                        element.textContent = this.props.product.descr!;
                        if(element.scrollHeight > 32){
                            if(element.textContent !== null){
                                if(element.id === computedId){
                                    for(;;){
                                        if(element.scrollHeight <= 32){
                                            break;
                                        } else {
                                            element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
                                            if(element.scrollHeight <= 32){
                                                break;
                                            }
                                        }
                                    }
                                }
                            }
                        } else {
                            let computedId = this.props.product.productId + '_description';
                            if(element.id === computedId){
                                for(;;){
                                    if(element.scrollHeight > 32){
                                        element.textContent = element.textContent.replace(/\W*\s(\S)*$/, '...');
                                        break;
                                    } else {
                                        break;
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    private openMenu(){
        this.setState({topCategoryProductMenu: 0});
        this.setState({leftCategoryProductMenu: 0});
        if(this.state.menuOpened === false){
            let main = this.props.page === 'CatalogPage' ? $('#main-container-catalog') : this.props.page === 'SearchLayer' ? $('#search-layer-full-page') : $('#main-container-category-details')
            let mainHeight = main!!.height();

            if(!AppUtils.isPhoneOrTablet()){
                // desktop
                let left = $('#' + this.props.product.productId).offset()?.left !== undefined ? $('#' + this.props.product.productId).offset()?.left : 0;
                let top = $('#' + this.props.product.productId).offset()?.top !== undefined ? $('#' + this.props.product.productId).offset()?.top : 0;

                let newTop = top!! + 89 + 10;
                let newLeft = left!! + 110;
                this.setState({topCategoryProductMenu: newTop});
                this.setState({leftCategoryProductMenu: newLeft});

                main.height(mainHeight!!.toString());

                window.scrollTo({
                    top: $('#' + this.props.product.productId).offset()?.top,
                    behavior: 'smooth'
                });
                
            } else {
                let left = $('#' + this.props.product.productId).offset()?.left !== undefined ? $('#' + this.props.product.productId).offset()?.left : 0;
                let top = $('#' + this.props.product.productId).offset()?.top !== undefined ? $('#' + this.props.product.productId).offset()?.top : 0;
                let newTop = top!! + 89 + 10;

                this.setState({topCategoryProductMenu: newTop});
                this.setState({leftCategoryProductMenu: left});

                main.height(mainHeight!!.toString());
                
                window.scrollTo({
                    top: $('#' + this.props.product.productId).offset()?.top,
                    behavior: 'smooth'
                });
            }
            
            this.setState({menuOpened: true});
        }
    }

    private closeMenu(){
        if(this.state.menuOpened === true){
            this.setState({menuOpened: false});
        }
    }

    private goToProductDetails(history: any, product: IProductDto){
        console.log("[ProductButton] go to product page");
        // Go to product details page
        let hasImage = (product.image === null || product.image === undefined) ? false : (product.image === "") ? false : true;
        let queryParams = {name: product.name !== null ? encodeURIComponent(product.name) : "", hasImage: hasImage};
        let link = `/products/${product.productId}?${querystring.stringify(queryParams)}`;
        history.push(link, {image: product.image, type: product.imageType, pageFrom: this.props.page, completePathPage: this.props.completePathPage});
    }

    // Meatball menu content render
    private renderMainMenu(): JSX.Element {
        return <div className={'product-menu-container'} style={{top: this.state.topCategoryProductMenu, left: this.state.leftCategoryProductMenu}}>
                <div className={"category-menu-options-main-content"}>
                    <div style={{width: '100%'}} id={"category-menu-options-inner-content"}>
                        <div className={"category-menu-options-main-title-content"}>
                            <p className={"category-menu-options-main-title"}>Cosa vuoi fare?</p>
                            <div onClick={() => this.closeMenu()} style={{cursor: 'pointer'}}>
                                <CloseMenuIcon widht={'20px'} height={'20px'} fill={'#000000'}/>
                            </div>
                        </div>
                    </div>
                    <div className={"category-meatball-row"}></div>
                    <Route render={({history}) => { return <p className={"product-menu-link"} onClick={() => {this.goToProductDetails(history, this.props.product)}}>{"Visualizza dettaglio prodotto".toUpperCase()}</p>}}/>
                    {
                        !this.props.isNoCategory && ((this.props.page === 'CatalogPage' || this.props.page === 'SearchLayer') ? <p className={"product-menu-link-delete"} onClick={() => {this.props.deleteFromCatalog(this.props.product)}}>{"Elimina da catalogo".toUpperCase()}</p>
                        : <p className={"product-menu-link-delete"} onClick={() => {this.props.deleteFromCategory(this.props.product)}}>{"Elimina da questa categoria".toUpperCase()}</p>)
                    }
                    
                </div> 
        </div>
    }

    render(){
        return <div>
                {this.state.menuOpened && <div className={"overlay-class"}></div> /* Overlay div */}
                {
                    this.state.menuOpened && this.renderMainMenu()
                }
                <div className={this.state.menuOpened ? "product-button-container product-button-ontop" : "product-button-container"} id={this.props.product.productId!!}>
                <div className={"product-button-container-info"}>
                    {
                        this.props.product.image !== undefined ? <div className={"product-button-image-container"} style={{opacity: 1}}>
                            <img src={"data:" + this.props.product.imageType + ";base64," + this.props.product.image} className={"product-button-image"}/> 
                        </div> : <div className={"product-button-image-container product-no-image"}>
                            <Camera className={"product-button-camera-image"} />
                        </div>
                    }
                    <div className={"product-button-info-content"}>
                        <div className={"product-button-badge-category-container"}>
                            {
                                _.map(this.props.product.categories?.slice(0, this.state.categoriesToShow), (value: ICategoryDto, index: number) => {
                                    return <div key={index} className={"product-button-category-badge"} style={{backgroundColor: value.color!!}}></div>
                                })
                            }
                            {
                                this.state.remainingCategories > 0 && <p className={"product-button-remaining-cat"}>{"+" + this.state.remainingCategories}</p>
                            }
                            {
                                this.state.remainingCategories === 0 && <p className={"product-button-remaining-cat"}>&nbsp;</p>
                            }
                        </div>
                        <div className={"product-button-title-and-desc-container-main"}>
                            <p className={"product-button-product-name"}>{this.props.product.name}</p>
                            {this.getDescriptionOnRows(this.props.product.descr!!)}
                        </div>
                    </div>
                </div>
                <div className={"product-button-container-actions"}>
                    <p className={"product-button-product-price"}>{(parseInt(this.props.product.amount!!)/100).toLocaleString('it-IT', {
                            style: 'currency',
                            currency: 'EUR',
                            })}
                    </p>
                    <div className={"product-button-container-button-dots"} onClick={() => {this.state.menuOpened === false && this.openMenu()}}>
                        <Dots className={"product-button-dots-icon"}/>
                    </div>
                </div>
            </div>
        </div>
    }

    private setHighlightedSearchText(descriptionText: string): any {
        return {__html: DOMPurify.sanitize(descriptionText)}
    }

    private getDescriptionOnRows(description: string): JSX.Element { // Max rows of 40 characters
        if(description === null || description === undefined || description.length === 0){
            return (<React.Fragment></React.Fragment>);
        } else {
            let searchInputValue: string | undefined = this.props.highlightedText;
            
            let completedString: string = description;
            let sliced: string = "";
            let forceSecondaryRow: boolean = false;

            if(description.toLowerCase().includes(searchInputValue!))
            {
                completedString = "";
                let pos = description.toLowerCase().indexOf(searchInputValue!); // starting pos of the search keyword in the description
                sliced = description.slice(pos, pos + searchInputValue!.length); // Sliced keyword from description

                let slicedArrayCheck = sliced.split(" ");
                
                if(slicedArrayCheck.length > 1)
                {
                    
                    for(let i = 0; i < slicedArrayCheck.length; i++)
                    {
                        if(slicedArrayCheck[i].length > 2)
                        {
                            description = description.replace(slicedArrayCheck[i], `<b>${slicedArrayCheck[i]}</b>`);
                            completedString = description;
                        }
                    }
                } else {
                    completedString = description.replace(sliced, `<b>${sliced}</b>`);  
                }
            }

            let parts: string[] = completedString.split(" ");
            let row1Content: string = "";
            let row2Content: string = "";
            let startingTag = "<b>"
            let closingTag = "</b>"
            let rowLength = 40
            let mobileRows: string = ""
            for(let i = 0; i < parts.length; i++) {

                if(i === 0){
                    row1Content += parts[i];
                } else {
                    let total = row1Content.length + parts[i].length;
                    // Check if the provided word has the bold tag

                    if(parts[i].includes(startingTag) || parts[i].includes(closingTag))
                    {
                        rowLength = rowLength + 7
                    }

                    if(total <= rowLength && !forceSecondaryRow){
                        row1Content = row1Content + " " + parts[i];
                    } else {
                        forceSecondaryRow = true;
                        row2Content = row2Content + " " + parts[i];
                    }
                }      
            }

            mobileRows = row1Content + row2Content

            if(mobileRows.length > 40)
            {
                let rowsArray = []
                rowsArray = mobileRows.split(" ")
                
                for(let zIndex = 0; zIndex < rowsArray.length; zIndex++)
                {
                    /* console.log(rowsArray[zIndex])
                    console.log(searchInputValue) */
                    if(searchInputValue !== undefined)
                    {
                        if(rowsArray[zIndex].toLowerCase().includes(searchInputValue!.toLowerCase()))
                        {
                            /* console.log("Word found") */
                            if(zIndex < 1)
                            {
                                rowsArray = rowsArray.slice(0, 3)
                            } else {
                                rowsArray = rowsArray.slice(0, zIndex + 1)
    
                                let check = rowsArray.join(" ")
                                if(check.length > 30)
                                {
                                    check = check.slice(0, 30)
                                }
    
                                rowsArray = check.split(" ")
                                /* console.log(rowsArray) */
                            }
                            break;
    
                        }
                    } else {
                        rowsArray = rowsArray.slice(0, 3)
                    }
                }
                mobileRows = rowsArray.join(" ") + "..."

                /* console.log(rowsArray) */
            }



            return <div>
                {/* Web */}
                <Media query="(min-width: 1065px)" render={() => {
                {
                    return (
                        <React.Fragment>
                            <p dangerouslySetInnerHTML={this.setHighlightedSearchText(row1Content)} className={"product-button-product-description"}></p>
                            {row2Content !== "" ? <p className={"product-button-product-description"} dangerouslySetInnerHTML={this.setHighlightedSearchText(row2Content)}></p> :  <p className={"product-button-product-description"}>&nbsp;</p>}
                        </React.Fragment>
                    )
                }
                }}/>

                {/* Mobile */}
                <Media query="(max-width: 1064px)" render={() => {
                    return <React.Fragment>
                    <p dangerouslySetInnerHTML={this.setHighlightedSearchText(mobileRows)} className={"product-button-product-description"}></p>
                </React.Fragment>
                }}/>
            </div>
        }
    }
}